import { Component } from 'preact';
import PropTypes from 'prop-types';

// Utils
import { actionHandler } from '../../../../utilities/form/formUtils';

// Components
import Label from '../../../Form/Label';
import Description from '../../../Form/Description';
import Icon from '../../../Global/Icon';

class InputCheckboxButtons extends Component {
  constructor(props) {
    super(props);
    this.onInput = this.onInput.bind(this);
    const {
      values,
      id,
    } = this.props;
    this.state = {
      active: false,
    };

    // If Value already exists and it's true, then set to true again
    if (Object.hasOwnProperty.call(values, id) && values[id] === true) {
      this.state = {
        ...this.state,
        active: true,
      };
    }
  }

  onInput(event) {
    const {
      actions,
      dispatch,
      onChange,
      values,
      setValues,
    } = this.props;
    const { active } = this.state;
    this.setState({
      active: !active,
    });

    // If isLink then the action should be fired on the label, and not the checkbox
    if (actions.length > 0) {
      actionHandler(actions, onChange, event, dispatch, values, setValues);
    } else {
      onChange(event);
    }
  }

  render() {
    const {
      id,
      label,
      onBlur,
      desc,
      icon,
      required,
    } = this.props;
    const { active } = this.state;
    return (
      <div className="form__field form__field--checkbox-buttons">

        {/* Input Field */}
        <input
          className="form__item"
          type="checkbox"
          id={id}
          name={id}
          value={id}
          required={required}
          onBlur={onBlur}
          checked={active}
          onChange={e => this.onInput(e)}
        />

        <div className="form__item-box">

          {icon &&
          <Icon icon={icon}/>
          }

          {/* Label */}
          {label &&
          <Label id={id} label={label}/>
          }

          {/* Description */}
          {desc &&
          <Description desc={desc}/>
          }

        </div>

      </div>
    );
  }
}

export default InputCheckboxButtons;

InputCheckboxButtons.defaultProps = {
  label: null,
  desc: null,
  required: false,
  icon: null,
  actions: [],
};

InputCheckboxButtons.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  actions: PropTypes.object,
  label: PropTypes.string,
  desc: PropTypes.string,
  required: PropTypes.bool,
  icon: PropTypes.string,
  setValues: PropTypes.func.isRequired,
};
